import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Tooltip } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { formatInternational, getCountryCodeFromPhoneNumber, } from 'lib-shared-phone-numbers';
import { memo } from 'react';
const NumberItem = ({ number, className, disabled, changeFromNumber, index, }) => {
    let numberLabel = null;
    let recordLabel = null;
    const phoneNumberFormat = formatInternational(number.e164_format) || number.e164_format;
    const regionCode = (getCountryCodeFromPhoneNumber(number.e164_format) || '').toUpperCase() ||
        'Unknown';
    if (number.name !== undefined &&
        number.name !== null &&
        typeof number.name === 'string') {
        numberLabel = (_jsx(Tooltip, Object.assign({ content: number.name, dark: true }, { children: _jsxs("em", { children: [" (", number.name, ")"] }) })));
    }
    if (number.record_outbound_calls && number.record_outbound_calls === true) {
        recordLabel = (_jsx(Tooltip, Object.assign({ content: `Outbound call recording is active on ${phoneNumberFormat}`, dark: true }, { children: _jsx("em", Object.assign({ className: "recording-outbound" }, { children: _jsx(DixaIcon, { icon: "rec" }) })) })));
    }
    return (_jsx("li", Object.assign({ role: "presentation", "aria-disabled": disabled, className: classNames(className, ' menuitem', { disabled }), style: { cursor: 'pointer' } }, { children: _jsxs("a", Object.assign({ href: "#", role: "menuitem", tabIndex: -1, onClick: (event) => {
                if (disabled) {
                    event.preventDefault();
                }
                if (disabled) {
                    return;
                }
                changeFromNumber(number);
            } }, { children: [_jsx("div", { className: 'flag ' + regionCode.toLowerCase() }), _jsxs("span", Object.assign({ className: "number" }, { children: [phoneNumberFormat, " ", numberLabel] })), recordLabel] })) }), index));
};
export default memo(NumberItem);
